// Small Sales-local helpers (Sales does not import from the Accounts module).
import { T, text } from "../ui/kit/tokens";

export function SectionCard({ title, subtitle, actions, children, pad = 16 }) {
    return (
        <section style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: T.radius, marginBottom: 20 }}>
            {(title || actions) && (
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", padding: "14px 16px", borderBottom: `1px solid ${T.borderSoft}` }}>
                    <div style={{ minWidth: 0 }}>
                        <h3 style={text.section}>{title}</h3>
                        {subtitle && <div style={{ ...text.caption, marginTop: 4, maxWidth: 720 }}>{subtitle}</div>}
                    </div>
                    {actions && <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>{actions}</div>}
                </div>
            )}
            <div style={{ padding: pad }}>{children}</div>
        </section>
    );
}

export const trim = (v) => (typeof v === "string" ? v.trim() : v);
export const panError = (pan) => (pan && !/^[0-9]{9}$/.test(pan.trim()) ? "PAN must be 9 digits." : "");
export const emailError = (e) => (e && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim()) ? "Check the email address." : "");
// Masked bank account number: last 4 digits only.
export const maskAccount = (no) => (no ? `•••• ${String(no).slice(-4)}` : "—");
